<template>
    <div class="salary" style="background-color:rgba(180,214,242, 0.2);">
         <h3>家属福利</h3>

        <div class="albums">
         <el-card  v-for="(item, index) in albums" :key="index" :style="{marginLeft:index==0?'0px':'13px'}" class="album" shadow="never" :body-style="{ padding: '0px' }">
         <div>
         <img :src="item.url"  alt style="width:380px;height:180px;"/>
         <span style="font-size:1.125rem;line-height:1.75rem;color: #1A1A1A;font-weight: 600;text-align: center;display: block;margin-top: 50px;margin-bottom:15px">{{item.title}}</span>
         <!-- <div v-html="item.desc" style="font-size:.875rem;color:#777777"></div>    -->
         </div>
         </el-card>
         </div>
    </div>
</template>

<style scoped>

h3 {
  padding-top: 50px;
  padding-bottom: 50px;
  font-size: 24px;
  line-height: 36px;
  color: #1A1A1A;
}

.el-card{
  border-radius: 10px
}
.albums{
  position: relative;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: center;
  text-align: center;
  padding-bottom: 50px;
}
.album{
  height: 300px;
  border: 1px solid #EEEEEE;
}
</style>

<script>
import { onActivated } from 'vue';
export default {

    data () {
    return {
     msg: '家属福利',
     albums:[
        { url: require('../assets/familybenefits/album0.png') ,
          title: '儿童节礼品',
          desc:'六一儿童节来临之际，<br/>公司为员工子女精心挑选并送上节日礼物。'
        },
        { url: require('../assets/familybenefits/album1.png') ,
          title: '家属保险福利',
          desc:'公司为员工提供补充商业保险福利计划，<br/>员工可通过弹性自选让父母、<br/>配偶、子女也享受保险福利。'
        },
        { url: require('../assets/familybenefits/album2.png') ,
          title: '家属体检福利',
          desc:'员工亲人的健康，既是员工的责任和牵挂，<br/>也是让员工放下后顾之忧、安心工作的精神支柱。<br/>公司每年为员工提供了1名家属半价体检的福利，<br/>并开放亲友体检优惠通道。'
        },]
    };
    },
    onActivated (){

    }
}
</script>



// WEBPACK FOOTER //
// src/components/FamilyBenefits.vue